export enum SessionStorageKey {
  SELECTED_FILTER_OPTIONS = 'selectedFilterOptions',
  PINNED_TABLES = 'pinnedTables',
  TRACKED_BOTS = 'trackedBots',
  CHAT = 'chat',
  BOT_ERROR = 'botError',
  LOBBY_TABLES_SEARCH_FILTER = 'lobbyTablesSearchFilter',
  AVAILABLE_BOTS_SEARCH_FILTER = 'availableBotsSearchFilter',
  ACTIVE_TABLES_SORTING = 'activeTablesSorting',
}
